import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Menu,
  MenuItem,
  Box,
  Typography,
  ListItemText
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { languages } from '../data/Languagelist';

const LanguageDropdown: React.FC = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  
  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[5]; // Default to English
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    handleClose();
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        sx={{
          minWidth: 80,
          color: "text.primary",
          textTransform: 'none'
        }}
        endIcon={<ArrowDropDownIcon sx={{ color: "text.primary" }} />}
      >
        <Typography variant="subtitle2">{currentLanguage.name}</Typography>
      </Button>
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            maxHeight: 300,
            minWidth: 120,
            mt: 0.5,
            boxShadow: '0px 2px 8px rgba(0,0,0,0.15)'
          }
        }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={language.code === currentLanguage.code}
          >
            <ListItemText>
              <Typography variant="body2">{language.name}</Typography>
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageDropdown;